<template>
  <div class="bg" ref="scrollArea" @wheel="handleScroll">
    <!-- banner -->
    <div class="top">
      <div class="bigTitle">
        We are your <span class="blueHighLight">Research Team</span></br> on the Ground in <span class="redHighLight">Asia</span>
      </div>
      <div class="subtitle">
        Holden can guide you to your <span class="redHighLight">success</span>
      </div>
    </div>
    <div class="mainValue">
      <div class="maintitle">
        <span class="blueHighLight">Who</span> We Are
      </div>
      <div class="maintext">
        We are an international-local company——we provide local insights in carrying out internationally recognized methodologies and practices for clients all over the globe.
      </div>
      <div class="maintitle">
        <span class="blueHighLight">What</span> We Do
      </div>
      <div class="maintext">
        We support our clients’ success by providing Qualitative and Quantitative services. Our proprietary Panels of Physicians, Patients, & Consumers provide candid feedback from your study targets with clear implications for your business needs. We also develop and apply innovative research technologies/practices in order to provide quality results efficiently.
      </div>

      <div class="maintitle">
        <span class="blueHighLight">Why</span> Reach Us
      </div>
      <div class="maintext">
        We contribute to our clients' success by providing data, information, & insight-- Direct feedback from our client’s research targets.
      </div>
      <div class="maintitle">
        <span class="blueHighLight">Where</span> We Are
      </div>
    </div>
    <!-- map -->
    <asia-map />
    <!-- We grow together with -->
    <div class="partner">
      <div class="text">
        <div class="title">
          <span class="blueHighLight">Our</span> Peers
        </div>
        <div class="value">
          <a href="https://www.intellus.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/intellus.png" class="one"></a>
          <a href="https://www.qrca.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/qrca.png" class="two"></a>
          <a href="https://www.jmra-net.or.jp/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/jmar-net.png" class="three"></a>
          <a href="http://www.cmra.org.cn/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cphmra.png" class="four"></a>
          <a href="https://www.quirks.com/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/quirks.png" class="five"></a>
          <a href="http://www.cmra.org.cn/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cmra.png" class="six"></a>
          <a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png" class="seven"></a>

        </div>
      </div>
    </div>

    <!-- CMRA Certificate logo   -->
    <div class="cmra">
      <div class="one">
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cmraLogo.png" alt="">
        </div>
        <div class="title">
          <div class="firstTitle redHighLight">CMRA</div>
          <div class="secondTitle">Market research personal information security protection requirements</div>
        </div>
      </div>
      <div class="two">
        <div class="title">
          <div class="firstTitle redHighLight">ISO</div>
          <div class="secondTitle">Market, opinion，social research, insights and data analytics</div>
        </div>
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2023/09/06/8/1693988218250.png" alt="">
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { getNewsList, getCustomerList, actionRecords, advertisementFlow } from "@/api/api";
import download from "downloadjs";
import DownLoad from "@/components/downLoad";
import AsiaMap from "@/components/asiaMap";

export default {
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      DialogShow: false,
      autoplay: true,
      scroll: 0,
      caseList: [],
      downloadfile: "",
      url: "",
      slide: 0,
      sliding: null,
      newsList: [],
      topFlag: []
    };
  },
  created() {
    this.loading();
    this.getNewsList();
    this.getCustomerList();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
    //  this.getNewsList(2);
  },
  mounted() {
    //调用方法
    this.slideBanner();
  },

  components: { DownLoad, AsiaMap },
  methods: {
    handleScroll(event) {
      const container = this.$refs.scrollContainer;
      const delta = Math.sign(event.deltaY); // 获取滚动方向

      if (delta > 0) {
        container.scrollTop += window.innerHeight; // 向下滚动一整屏
      } else {
        container.scrollTop -= window.innerHeight; // 向上滚动一整屏
      }

      event.preventDefault(); // 阻止默认滚动行为
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "aboutUs",
          source: "",
          information: "关于我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "aboutUs",
          source: this.$route.query.source,
          information: "关于我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },

    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
}
.bg {
  // height: 100vh;
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Homepage_Background.png);
  background-size: cover;
  color: #1e364e;
}
.redHighLight {
  color: #e73323;
}
.blueHighLight {
  color: #4c8fd5;
}
.top {
  padding-top: 100px;
  .bigTitle {
    text-align: center;
    font-size: 60px;
    font-weight: 700;
  }
  .subtitle {
    font-size: 35px;
    text-align: center;
    padding: 20px 0;
  }
}
.mainValue {
  text-align: center;
  .maintitle {
    font-size: 40px;
    font-weight: 700;
  }
  .maintext {
    font-size: 20px;
    padding: 50px 200px;
  }
}
.partner {
  padding: 80px 100px 20px 120px;
  position: relative;
  overflow: hidden;
  .title {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 40px;
    text-align: center;
  }
  .value {
    img {
      width: 20%;
      margin: 2% 4%;
    }
    .two {
      width: 25%;
    }
    .three {
      width: 30%;
    }
    .six {
      width: 15%;
    }
    .five {
      width: 15%;
    }
    .seven {
      width: 18%;
    }
  }
}
.cmra {
  padding: 100px 120px;
  overflow: hidden;
  text-align: center;
  display: flex;
  justify-content: space-between;
  .one,
  .two {
    width: 45%;
    display: flex;
    // align-items: center;
    .value {
      width: 300px;
      img {
        width: 100%;
      }
    }
    .title {
      .firstTitle {
        font-size: 40px;
        font-weight: 700;
      }
      .secondTitle {
        font-size: 23px;
      }
    }
  }
  .two {
    .value {
      img {
        padding: 0 20px;
      }
    }
  }
}
.news {
  padding: 0px 120px;
  font-size: 18px;
  position: relative;

  .bigtitle {
    font-size: 40px;
    font-weight: 700;
    color: #ccc;
  }
  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 120px;
    bottom: 20px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .topnews {
      width: 50%;
      height: 100%;
      .topNews {
        border: 1px solid #d5dbe5;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        padding: 14px;
        cursor: pointer;
        margin-bottom: 60px;

        img {
          width: 100%;
        }
        .title {
          margin-top: 10px;
          font-weight: 700;
        }
        .label {
          margin: 15px 10px 0 0;
          font-size: 12px;
          display: inline-block;
          padding: 0.7px 7.5px 2px;
          background: #e8f2ff;
          border-radius: 4px;
          color: #2186c8;
        }
        .newsDesc {
          margin-top: 20px;
        }
      }
    }
    .notopnews {
      width: 47%;
    }
    .one {
      display: flex;
      cursor: pointer;
      padding: 14px;
      width: 100%;
      margin: 0px auto 20px;
      border: 1px solid #d5dbe5;
      border-radius: 8px;
      box-shadow: 4px 4px 4px 0 #d5dbe5;
      img {
        width: 300px;
        height: 170px;
      }
      .title {
        margin-left: 10px;
      }
      .label {
        margin-left: 10px;
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
      }
    }
    .two {
      width: 40%;
    }
  }
}
.check {
  margin-right: 10px;
}
/deep/ .el-dialog__wrapper {
  .el-dialog {
    width: 100% !important;
    .el-dialog__footer {
      .el-button {
        font-size: 70px;
        padding: 20px;
      }
    }
  }
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {
  .banner {
    .value {
      width: 45%;
      font-size: 80px;
    }
  }
  .intro {
    .img {
    }
    .image1 {
      width: 800px;
    }
    .image2 {
      width: 600px;
      right: 640px;
      top: 440px;
    }
    .image3 {
      width: 100px;
      height: 100px;
      right: 120px;
      top: 640px;
    }
    .image4 {
      width: 440px;
      height: 440px;
      top: 800px;
      right: 220px;
    }
    .text {
      padding-top: 120px;
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .Purpose {
    .text {
      // width: 49%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .team {
    .image1 {
      width: 1500px;
    }
    .text {
      padding-top: 120px;
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
      span {
        font-size: 70px;
      }
    }
  }
  .Clients {
    height: 1300px;
    .text {
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
        padding-bottom: 30px;
        height: 600px;
      }
    }
  }
  .partner {
    .title {
      font-size: 80px;
    }
    .value {
      text-align: center;

      img {
        width: 80%;
        margin: 10% 8%;
      }
      .two {
        width: 80%;
      }
      .three {
        width: 80%;
      }
      .five {
        width: 80%;
      }
      .six {
        width: 60%;
      }
      .seven {
        width: 80%;
      }
    }
  }
  .cmra {
    display: block;
    .one,
    .two {
      width: 100%;
      align-items: center;

      .value {
        width: 1500px;
      }
      .title {
        .firstTitle {
          font-size: 80px;
        }
        .secondTitle {
          font-size: 70px;
        }
      }
    }
    .one {
      padding-bottom: 100px;
    }
    .two {
      .value {
        img {
          padding: 0 50px;
        }
      }
    }
  }
  .news {
    padding-bottom: 100px;
    .bigtitle {
      font-size: 80px;
    }
    .more {
      font-size: 40px;
      bottom: 10px;
    }
    .newsList {
      display: block;
      .topnews {
        width: 100%;
        .topNews {
          .title {
            font-size: 70px;
          }
          .label {
            font-size: 50px;
            margin-bottom: 10px;
          }
          .newsDesc {
            font-size: 60px;
          }
        }
      }
      .notopnews {
        width: 100%;
      }
      .one {
        flex-wrap: wrap;

        img {
          width: 100%;
          height: 800px;
        }
        .label {
          font-size: 50px;
          margin-bottom: 10px;
        }
        .title {
          font-size: 70px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
/deep/.el-carousel__arrow {
  width: 50px;
  height: 50px;
  font-size: 40px;
}
@media screen and (max-width: 576px) {
  /deep/ .el-carousel__arrow {
    width: 100px;
    height: 100px;
    font-size: 80px;
  }
  /deep/ .el-carousel__container {
    height: 1000px;
  }
}
</style>